import { render, staticRenderFns } from "./CommittedOfferList.vue?vue&type=template&id=2d540197&scoped=true&"
import script from "./CommittedOfferList.vue?vue&type=script&lang=js&"
export * from "./CommittedOfferList.vue?vue&type=script&lang=js&"
import style0 from "./CommittedOfferList.vue?vue&type=style&index=0&id=2d540197&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d540197",
  null
  
)

export default component.exports